module.exports = __webpack_public_path__ + "img/booth-table-4.c24a8469.png";